module.exports = __webpack_public_path__ + "img/privatbank.c75012dc.png";